import { ComponentCommunicationService } from 'src/app/component-communication.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenderEnum } from 'src/app/model/enums/GenderEnum';
import { EnumConverterService } from 'src/app/services/EnumConverterService';

@Component({
  selector: 'app-application-custom-beneficiary',
  templateUrl: './application-custom-beneficiary.component.html',
  styleUrls: ['./application-custom-beneficiary.component.css'],
})
export class ApplicationCustomBeneficiaryComponent implements OnInit {
  @Input()
  customBeneficiaryFormGroup: FormGroup;
  prevInitials = '';
  firstInitial = true;

  dateMask: string;
  genderList = this.enumConverterService.toBaseList('GenderEnum', GenderEnum);

  constructor(
    private enumConverterService: EnumConverterService,
    private componentCommunication: ComponentCommunicationService,
  ) {}

  ngOnInit(): void {
    this.customBeneficiaryFormGroup
      .get('initials')
      .valueChanges.subscribe(newValue => this.addDotsToInitials(newValue));
  }

  addDotsToInitials(newValue: string): void {
    if (this.firstInitial) {
      this.prevInitials = this.customBeneficiaryFormGroup.get('initials').value
        ? this.customBeneficiaryFormGroup.get('initials').value
        : '';
      this.firstInitial = false;
    }

    if (!newValue) {
      return;
    }

    const lastChar = newValue.charAt(newValue.length - 1);
    if (lastChar === '.') {
      return;
    }

    if (this.prevInitials && this.prevInitials.length > newValue.length) {
      this.customBeneficiaryFormGroup
        .get('initials')
        .patchValue(newValue.substring(0, newValue.length - 1));
    } else {
      this.customBeneficiaryFormGroup
        .get('initials')
        .patchValue(newValue.toUpperCase() + '.');
    }

    this.prevInitials = this.customBeneficiaryFormGroup.get('initials').value;
  }

  get dateMaskFormat(): string {
    return this.componentCommunication.getDateFormat();
  }
}
